import React from 'react';
import { Button, Group, Stack, Text } from '@mantine/core';
import { TradeEntryFacilitiesSection } from './trade-entry-facilities-section';
import { DateInput } from '@mantine/dates';
import IonIcon from '@reacticons/ionicons';
import { highlightToday } from 'app/utils/util-functions';
import { tradeTypeOptions, tradeAssociationOptions, tradeDocsTypeOptions, transferTypeOptions, interestTreatmentOptions, assignmentFeePayTypeOptions, settlementMethodOptions, tradePaymentTypeOptions, booleanOptions } from 'app/models/dropdown-options';
import { NewSelectInput } from 'app/views/components/inputs/selects/NewSelectInput';
import { TextLabelInput } from 'app/views/components/inputs/TextLabelInput';
import { NewTextInput } from 'app/views/components/inputs/NewTextInput';
import { TradeEntryCounterParty } from './trade-entry-counterparties-section/trade-entry-counter-party';
import { TradeEntryDealSearch } from './trade-entry-deal-section/trade-entry-deal-search';
import SectionTitle from 'app/views/components/Headers&Text/SectionTitle';
import { showTradeId } from '../utils/master-trade-util';
type Props = {
  form: any
  loading: boolean
  onDealChange: (value?: string | null) => void
  onBuyerSellerChange: (value: any) => void
  createTradeEntry: () => void
  cancelTradeEntry: () => void
  createApprovedTradeEntry: () => void
}

export function TradeEntryFormPresentation({ form, loading, onDealChange, onBuyerSellerChange, /* createTradeEntry, */ cancelTradeEntry, createApprovedTradeEntry }: Props) {
  return (

    <Stack className='tradeEntryCreationPage'>
      <Stack className="tradeEntrySection">
        {/* Info: Booking Details */}

        <SectionTitle>Booking Details</SectionTitle>
        <Group className='tradeEntryInputGroup' >
          <NewTextInput disabled={loading} label="Internal Trade ID" w="276px" placeholder='Trade ID' {...form.getInputProps('clientId')} />
          <NewTextInput disabled={loading} label="Closer" w="276px" placeholder='Closer' {...form.getInputProps('closer')} />
          <NewTextInput disabled={loading} label="Counterparty Closer" w="276px" placeholder='Counterparty Closer' {...form.getInputProps('counterpartyCloser')} />
          <NewTextInput disabled={loading} label="Trader" w="151px" placeholder='Trader' {...form.getInputProps('trader')} />
          <NewTextInput disabled={loading} label="PM" w="123px" placeholder='PM' {...form.getInputProps('pm')} />
          <NewTextInput disabled={loading} label="Desk" w="83px" placeholder='Desk' {...form.getInputProps('desk')} />
          <NewTextInput disabled={loading} label="Trade Group ID" w="123px" placeholder='Trade Group ID' {...form.getInputProps('tradeGroupId')} />
          <NewSelectInput disabled={loading} label="Settlement Method" data={settlementMethodOptions} w="120px" placeholder='Method' {...form.getInputProps('settlementMethod')} />
          {showTradeId(form.values.settlementMethod) ? <NewTextInput disabled={loading} w="123px" placeholder={`${form.values.settlementMethod} Trade ID`} {...form.getInputProps('outsideTradeId')} /> : null}
        </Group>
      </Stack >

      {/* Info: Counter Parties */}
      <Stack className="tradeEntrySection">
        <SectionTitle>Counterparties</SectionTitle>
        <Group noWrap className="tradeEntryInputGroup">
          <TradeEntryCounterParty loading={loading} isMyEntityBlock={true} title="My Entity" onBuyerSellerChange={onBuyerSellerChange} form={form} />
          <TradeEntryCounterParty loading={loading} isMyEntityBlock={false} title="Counterparty" form={form} />
        </Group>
      </Stack>


      <Stack className="tradeEntrySection">
        {/* Info: Terms of Trade */}
        <SectionTitle>Terms of Trade</SectionTitle>
        <Group className="tradeEntryInputGroup">
          <Group noWrap className="dataEntrySubSection">
            <TextLabelInput label="Trade Date">
              <DateInput
                disabled={loading}
                w="130px"
                placeholder='Trade Date'
                valueFormat='DD-MMM-YYYY'
                firstDayOfWeek={0}
                classNames={{
                  input: 'newInput',
                  wrapper: 'newInputWrapper',
                  rightSection: 'customRightSection',

                }}
                rightSection={<IonIcon size="large" name="chevron-down-outline"></IonIcon>}
                getDayProps={highlightToday()}
                {...form.getInputProps('tradeDate')}
              /></TextLabelInput>
          </Group>
          <NewSelectInput disabled={loading} label="Trade Type" data={tradeTypeOptions} w="120px" placeholder='Trade Type' {...form.getInputProps('tradeType')} />
          <NewSelectInput disabled={loading} label="Trade Association" data={tradeAssociationOptions} w="85px" placeholder='Trade Association' {...form.getInputProps('tradeAssociation')} />
          <NewSelectInput disabled={loading} label="Trade Docs" data={tradeDocsTypeOptions} w="110px" placeholder='Trade Docs' {...form.getInputProps('tradeDocsType')} />
          <NewSelectInput disabled={loading} label="Transfer Type" data={transferTypeOptions} w="125px" placeholder='Transfer Type' {...form.getInputProps('transferType')} />
          <NewSelectInput disabled={loading} label="Interest Treatment" data={interestTreatmentOptions} w="195px" placeholder='Interest Treatment' {...form.getInputProps('interestTreatment')} />
          <NewSelectInput disabled={loading} label="Assignment Fee Split" data={assignmentFeePayTypeOptions} w="223px" placeholder='Assignment Fee Split' {...form.getInputProps('assignmentFeePayType')} />
          <NewSelectInput disabled={loading} label="Payment" data={tradePaymentTypeOptions} w="125px" placeholder='Payment Type' {...form.getInputProps('paymentType')} />
          <NewSelectInput disabled={loading} label="Disable DC/CoC" data={booleanOptions} w="85px" placeholder='Yes/No' {...form.getInputProps('disableDCCoC')} />
        </Group>
      </Stack>

      {/* Info: Deal Section */}
      <Stack className="tradeEntrySection">
        <SectionTitle>Traded Deal</SectionTitle>
        <div className='tradeEntryInputGroup'>
          <Stack className="tradeEntryDealSectionStack">
            <Group noWrap className="tradeEntryCounterpartiesTitleSection">
              <TradeEntryDealSearch loading={loading} onChange={onDealChange} value={form.values.dealId} />
            </Group>
            <Group noWrap className="tradeEntryCounterpartiesSubSections">
              <Group noWrap w="35%" className="dataEntrySubSection">
                <TextLabelInput label="Deal Name" > <Text className='newInput'>{form.values.deal?.dealName ?? ''}</Text>
                </TextLabelInput>
              </Group>
              <Group noWrap w="12%" className="dataEntrySubSection">
                <TextLabelInput label="CUSIP" > <Text className='newInput'>{form.values.deal?.cusip ?? ''}</Text>
                </TextLabelInput>
              </Group>
              <Group noWrap w="12%" className="dataEntrySubSection">
                <TextLabelInput label="LX ID" > <Text className='newInput'>{form.values.deal?.lxId ?? ''}</Text>
                </TextLabelInput>
              </Group>
              <Group noWrap w="30%" className="dataEntrySubSection">
                <TextLabelInput label="Deal ID" > <Text className='newInput'>{form.values.deal?.systemId ?? ''}</Text>
                </TextLabelInput>
              </Group>
              <Group noWrap w="10%" className="dataEntrySubSection">
                <TextLabelInput label="Client Deal ID" > <Text className='newInput'></Text>
                </TextLabelInput>
              </Group>

            </Group>
          </Stack>
        </div>
      </Stack>

      {/* Info: Facility Details */}

      {form.values.tradedFacilities && form.values.tradedFacilities.length > 0 &&
        <TradeEntryFacilitiesSection loading={loading} form={form} />
      }

      {/* Info: Bootons */}
      <Group noWrap className="tradeEntrySubmissionSection" style={{ gap: '33%' }}>
        <Button className="tradeEntrySubmissionCancel" onClick={cancelTradeEntry} loading={loading}>Cancel</Button>
        {/* <Button className="tradeEntrySubmissionCreate" onClick={createTradeEntry} loading={loading}>Create Draft Trade</Button> */} {/* Issue #6600 Disable draft trades & conceal 'Draft' from 'Trade Status' filter */}
        <Button className="tradeEntrySubmissionCreate" onClick={createApprovedTradeEntry} loading={loading} disabled={loading}>Create Open Trade</Button>
      </Group>
    </Stack>
  );
}
